var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1529_10368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5319 37.7049C18.7898 36.1101 19.0846 34.1542 19.4346 32.2044C19.539 31.6146 19.4101 31.2114 18.9679 30.8022C17.7643 29.6888 16.6037 28.5274 15.4247 27.3839C15.3387 27.2997 15.2404 27.2275 15.1667 27.1372C14.4298 26.2886 13.7359 25.3859 14.0982 24.1883C14.4667 22.9727 15.5659 22.5936 16.6835 22.395C18.4337 22.076 20.19 21.8232 21.9524 21.5825C22.4928 21.5103 22.7937 21.2756 23.0148 20.7942C23.678 19.3378 24.3903 17.9055 25.0842 16.4612C25.1641 16.2987 25.2377 16.1422 25.3237 15.9857C25.8764 14.9927 26.5089 14.0539 27.7862 13.9998C29.0389 13.9456 29.6407 14.8965 30.1443 15.8052C31.0224 17.3819 31.8392 19.0008 32.6252 20.6256C32.9077 21.2094 33.27 21.4441 33.9148 21.5163C35.5298 21.6908 37.1326 21.9556 38.7476 22.1783C38.7783 22.1783 38.809 22.1843 38.8397 22.1903C39.9819 22.425 41.1548 22.6838 41.6093 23.8995C42.0821 25.1572 41.3821 26.1382 40.553 26.9988C39.331 28.2626 38.0783 29.5023 36.8194 30.736C36.4509 31.0971 36.2913 31.416 36.408 31.9757C36.758 33.6246 37.0036 35.2916 37.2922 36.9466C37.3107 37.061 37.3475 37.1753 37.3598 37.2957C37.4703 38.4391 37.5317 39.6186 36.4387 40.3588C35.3947 41.075 34.2894 40.7019 33.27 40.1964C31.7102 39.42 30.1688 38.6136 28.6398 37.7831C28.1608 37.5243 27.7985 37.5243 27.3195 37.7952C25.9132 38.5956 24.4763 39.3418 23.0455 40.1061C22.7814 40.2445 22.5112 40.3829 22.2349 40.4973C19.9996 41.412 18.5196 40.4371 18.5442 37.7049H18.5319Z",
    fill: "#096784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1529_10368",
    x: 0.57006,
    y: 0.57006,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1529_10368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1529_10368",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.8ac5732796863e42280f8c96ed33cb91.svg";
export { ForwardRef as ReactComponent };